// extracted by mini-css-extract-plugin
module.exports = {"Share":"Share_Share__2BHtq","Share_top":"Share_Share_top__1DlzV","body":"Share_body__VOeAs","Share_link_card":"Share_Share_link_card__trYiA"};